angular.module('zc.commonApi')

.factory 'ProjectBreadcrumb', ($resource, $q, BaseProjectCrudService) ->
  class ProjectBreadcrumb extends BaseProjectCrudService

  new ProjectBreadcrumb(
    $resource
    $q
    '/api/master/projects/:projectId/breadcrumbs/:id'
    'breadcrumb'
    'breadcrumbs'
  )



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/breadcrumb_selector.service.coffee